'use strict';
'use es6';
/**
 * Converts an Iterable to a native JS structure.
 *
 * @param  {Iterable} subject to convert.
 * @return {Array|Object} native JS requivalent of `subject`.
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = toJS;
function toJS(subject) {
  if ((typeof subject === 'undefined' ? 'undefined' : _typeof(subject)) !== 'object' || !subject) {
    return subject;
  }
  if (typeof subject.toJS === 'function') {
    return subject.toJS();
  }
  if (typeof subject.toJSON === 'function') {
    return subject.toJSON();
  }
  return subject;
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/transmute/static-2.9/toJS.js
// module id = 173
// module chunks = 2 3